import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment/environment';

export interface RagChatRequest {
  session_id: string;
  message: string;
  language: string;
  company_id: number;
  room_id?: string;
  knowledge_scope: string;
  attachments?: File[];
}

export interface RagChatResponse {
  success: boolean;
  data: {
    session_id: string;
    answer: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class RagApiService {
  private http = inject(HttpClient);
  private readonly endpoint = `${environment.api.base_url}/rag/chat`;

  chat(request: RagChatRequest): Observable<RagChatResponse> {
    const formData = new FormData();
    formData.append('session_id', request.session_id);
    formData.append('message', request.message);
    formData.append('language', request.language);
    formData.append('company_id', String(request.company_id));
    if (request.room_id) {
      formData.append('room_id', request.room_id);
    }
    formData.append('knowledge_scope', request.knowledge_scope);
    request.attachments?.forEach(file => formData.append('attachments', file));
    return this.http.post<RagChatResponse>(this.endpoint, formData);
  }
}
